export default "__VITE_ASSET__54de8781__"